import React, { useState, useEffect } from "react"
import { Box } from "@rebass/grid/emotion"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"

import ModalNova from "@nutrafol/nutrafol-ui-kit/dist/ModalNova"
import { ButtonNova } from "@nutrafol/nutrafol-ui-kit/dist/ButtonNova"

import { useIsFirstRender } from "../../../../../hooks/useIsFirstRender"
import Image from "../../../../image"
import ImageArea from "../imagearea"
import PdpAtcRadio from "../../atcoptions/pdp-atc-radio"
import Dermbadge from "../../badge/badge"
import Icons from "../../icons/icons"
import CoreUpsell from "./upsell/coreproduct-upsell"
import Benefits from "../benefits/benefits"
import Tags from "../tags"
import GwpAtcAreaBanner from "../../gwp/gwpatcarea/gwpatcareabanner"
import GwpModalContent from "../../gwp/gwpatcarea/gwpmodalcontent"

import {
  ATCFullWrap,
  ATCWrap,
  TitleWrapFlex,
  TitleBadge,
  TitleAndInfo,
  ImageWrap,
  IconsBox,
  InfoDesk,
  InfoFlex,
  ModalContentImage,
} from "./atcarearadio.styled"
import {
  HEADER1,
  MODAL_HS,
  MODAL_FHKSML,
} from "./upsell/coreproduct-upsell-data"

const ModalContent = ({ image }) => {
  return (
    <ModalContentImage>
      <Image filename={image} classes="supplement-label" />
    </ModalContentImage>
  )
}

const AtcAreaRadio = ({ data, userState, isIntroAlt = true }) => {
  const {
    title,
    subtitle,
    mainimg,
    supplement_label,
    icons,
    questions,
    badge = null,
    altMainPdpImage,
    imageArea,
    copy,
    tags,
    gwpData = null,
  } = data

  const copy3 = `View Supplement Label`
  const [modalVisible, toggleModalVisible] = useState(false)
  const [upsellVisible, setUpsellVisible] = useState(false)
  const [upsellOption, setUpsellOption] = useState(null)
  const [gwpModalVisible, setGwpModalVisible] = useState(false)
  const [variant, setVariant] = useState(null)
  const isFirstRender = useIsFirstRender()

  useEffect(() => {
    if (isFirstRender) {
      return
    }
    if (!upsellVisible) {
      const IS3MON = ["BAL3-S01"].includes(upsellOption.sku)
      const ONETIMEMODE = IS3MON && variant === "a"
      segmentEvent("Modal Closed", {
        name: ONETIMEMODE ? MODAL_HS : MODAL_FHKSML,
      })
    }
  }, [upsellVisible])

  // attached to modal trigger
  const showModal = () => {
    toggleModalVisible(true)
    //document.querySelector('header').style.visibility = 'hidden'
    segmentEvent("Modal Viewed", {
      name: copy3,
    })
  }

  const upsellCallback = (resJson = [], cartSku, variant) => {
    /**
     **
     *Variant 1
     *When 3 month sub added to a cart, present upsell modal for 1oz Hair Serum - one time purchase
     *
     *
     *Variant 2
     *When 3 month sub added to a cart, present upsell modal for 1oz Hair Serum - added to subscription (3x1oz)
     **
     */
    if (resJson[0]?.cart_id) {
      setUpsellOption(
        userState.atcData.options.find((el) => el.sku.includes(cartSku))
      )
      if (variant && cartSku === "BAL3-S01") {
        setVariant(variant)
      }
      setUpsellVisible(true)
    } else {
      console.error("cart_id missing")
    }
  }

  const handleGwpModal = () => {
    segmentEvent("Modal Viewed", {
      name: gwpData.modal.title,
    })
    setGwpModalVisible(true)
  }

  return (
    <ATCFullWrap className="atc-full-wrap">
      <ATCWrap className=" row cf">
        <ImageWrap width={[1, 1, 1, 1 / 2]} className={``} order={[1, 1, 1, 0]}>
          <div className={`show-lg-up`}>
            <Image
              filename={mainimg}
              classes="product-image main-pdp-image"
              alt={altMainPdpImage || title}
            />
            <Box pt={[24, 24, 24, 90]}>
              <Dermbadge />
            </Box>
          </div>
          <ImageArea data={imageArea} />
        </ImageWrap>
        <TitleAndInfo width={[1, 1, 1, 1 / 2]} order={[0, 0, 0, 1]}>
          <div className="sticky">
            {gwpData ? (
              <GwpAtcAreaBanner
                data={gwpData}
                handleGwpModal={handleGwpModal}
              />
            ) : null}
            <TitleWrapFlex
              justifyContent={["center", null, null, "flex-start"]}
              alignItems={["center"]}
            >
              <Box>
                <TextElementNova
                  element="h2"
                  text={title}
                  className="Title-20-Super-Normal text-nova-base-black"
                />
              </Box>
              {badge ? (
                <TitleBadge ml={[8, 8, 8, 16]}>
                  <TextElementNova element="p" text={badge} className="" />
                </TitleBadge>
              ) : null}
            </TitleWrapFlex>
            <InfoDesk>
              <Box>
                <TextElementNova
                  className={`Caption-10-Dia-Uppercase text-center md:text-left`}
                  text={copy}
                />
              </Box>
            </InfoDesk>
            <div className={`hide-lg-up`}>
              <Image
                filename={mainimg}
                classes="product-image main-pdp-image"
                alt={altMainPdpImage || title}
              />
              <Box pt={[24, 24, 24, 90]}>
                <Dermbadge />
              </Box>
            </div>
            <InfoFlex>
              <Box order={[0, 0, 0, 1]} width={[1]}>
                {gwpData ? (
                  <PdpAtcRadio
                    state={userState}
                    data={data}
                    upsellCallback={upsellCallback}
                    atcCard={gwpData.atcCard}
                    handleGwpModal={handleGwpModal}
                  />
                ) : (
                  <PdpAtcRadio
                    state={userState}
                    data={data}
                    upsellCallback={upsellCallback}
                  />
                )}
              </Box>
              <Box
                width={[1]}
                pt={[24, 24, 16, 0]}
                pb={[0]}
                order={[1, 1, 1, 0]}
              >
                <TextElementNova
                  element="p"
                  text={subtitle}
                  className=" left Body-20-Dia-Normal"
                />
                <Box mt={[24, 24, 24, 32]} className="text-center">
                  <ButtonNova
                    label={copy3}
                    onClick={showModal}
                    level={"Textlink"}
                  />
                </Box>
              </Box>
            </InfoFlex>
            <IconsBox>
              <Icons data={icons} />
            </IconsBox>
            <Box pt={[0, 0, 0, 0]}>
              <Benefits items={questions} isIntroAlt={isIntroAlt} />
            </Box>
            <Box pt={[40, 40, 32, 24]}>
              <Tags items={tags} />
            </Box>
          </div>
        </TitleAndInfo>
      </ATCWrap>
      {modalVisible ? (
        <div className={`supplinkwrap`}>
          <ModalNova
            hideModal={() => toggleModalVisible(false)}
            modalSize="small"
          >
            <ModalContent image={supplement_label} />
          </ModalNova>
        </div>
      ) : null}
      {upsellVisible ? (
        <div className={`upsellwrap`}>
          <ModalNova
            hideModal={() => setUpsellVisible(false)}
            modalSize="small"
            title={HEADER1}
            fullHeightMobile={true}
          >
            <CoreUpsell upsellOption={upsellOption} variant={variant} />
          </ModalNova>
        </div>
      ) : null}
      {gwpModalVisible ? (
        <div className={`travelKitWrap`}>
          <ModalNova
            hideModal={() => setGwpModalVisible(false)}
            modalSize="small"
            title={gwpData.modal.title}
          >
            <GwpModalContent data={gwpData.modal} />
          </ModalNova>
        </div>
      ) : null}
    </ATCFullWrap>
  )
}

export default AtcAreaRadio
